import { render } from "./CreateStrategy.vue?vue&type=template&id=7018b270"
import script from "./CreateStrategy.vue?vue&type=script&lang=js"
export * from "./CreateStrategy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__